import { Address, Role } from "@prisma/client";
import { differenceInYears } from "date-fns";

export const getName = ({
  firstName,
  lastName,
}: {
  firstName?: string | null;
  lastName?: string | null;
}) => [lastName, firstName].filter((e) => !!e).join(" ");

export const getDisplayName = ({
  businessName,
  firstName,
  lastName,
}: {
  businessName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}) => businessName ?? getName({ firstName, lastName });

export const getAge = ({ dateOfBirth }: { dateOfBirth: Date | string }) => {
  const birthDate = new Date(dateOfBirth);
  return differenceInYears(new Date(), birthDate);
};

export const getAddress = ({
  address,
  city,
  zipCode,
}: {
  address: string | null;
  city: string | null;
  zipCode: string | null;
}) => [address, `${zipCode ? zipCode + " " : ""}${city}`].filter((e) => !!e).join(", ");

type ShortAddress = Pick<Address, "address" | "city" | "zipCode">;

type GetUserAddressUser = ShortAddress & {
  structure: {
    address: ShortAddress | undefined;
  } | null;
};

export const getUserAddress = (user: GetUserAddressUser): ShortAddress | null => {
  if (user.structure?.address) return user.structure?.address;
  if (user.address || user.city || user.zipCode) return user;
  return null;
};

export const getRoleLabel = (role: string): string => {
  switch (role) {
    case Role.acExpo:
      return "AC Expo";
    case Role.organiser:
      return "Organisateur";
    case Role.exhibitor:
      return "Exposant";
    case Role.tourismOperator:
      return "Opérateur de tourisme";
    case Role.placeManager:
      return "Gestionnaire de site";
    default:
      return "Rôle inconnu";
  }
};

export const getAgeRangeLabel = (age: number): string => {
  if (age < 18) return "Moins de 18 ans";
  if (age <= 24) return "18-24 ans";
  if (age <= 34) return "25-34 ans";
  if (age <= 44) return "35-44 ans";
  if (age <= 54) return "45-54 ans";
  if (age <= 64) return "55-64 ans";
  return "65+ ans";
};

export const formatAgeRange = (dateOfBirth: Date | string | null | undefined): string => {
  if (!dateOfBirth) return "Non renseigné";
  return getAgeRangeLabel(getAge({ dateOfBirth }));
};
